import { useState, useEffect } from "react";
import * as XLSX from 'xlsx';

import {
  Link,
  useNavigate,
  useSearchParams,
  useParams,
} from "react-router-dom";
import useAxios from "../hooks/useAxios";
import axiosInstance from "../apis/commonAPI";
import { PAGE_LIMITS, modulePermissions } from "../constants";
import { useSelector } from "react-redux";
import Loader from "../components/loader";
import Table from "../components/tables/table";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import {
  expertuserSlotFieldData,
  expertuserSlotTableData,
} from "../data/TableData";
import moment from "moment";
import UserQueryAlert from "../components/UserQueryAlert";
// import useUser from "../../hooks/useUser";
import { useForm, FormProvider } from "react-hook-form";


export default function ViewAllBookedSlots() {
  const { id } = useParams();

  const { SESSION_DATA, user } = useSelector((state) => state.user);
  const MODULE_URI = "/expert/expertlisting";
  const FETCH_API_URL = `booking/getExpertBookedSlots?`;
  const SUBMIT_EXP_BOOK_SLOT = `booking/getExpertBookedSlotsExcel`;
  // const CHANGE_STATUS_API_URL = `customer/change-customer-status?dataId=`;
  const CALL_CONNECT_URL = "users/connectBookedCall";


  // const currTime = moment().format("LT");
    const currTime = moment().format("hh:mm A");
  
  const currDate = moment().format("YYYY-MM-DD");

  const navigate = useNavigate();
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(PAGE_LIMITS[0]);
  const [totalCount, setTotalCount] = useState(0);
    const [downloadExcelData, setDownloadExcelData] = useState([]);
  

  const [tableData, setTableData] = useState([]);
  const [UserQueryFlag, setUserQueryFlag] = useState(false);
  const [CurrQueryMsg, setCurrQueryMsg] = useState("No user query");
    const [addUpdate, setAddUpdate] = useState(false);
    const [downloadExcelFlag, setDownloadExcelFlag] = useState(false);

   
  
  

  const [resData, error, loading, axiosFetch] = useAxios();
  const [callConnectResp, errorCallConn, loadingCallConn, axiosCallConn] =
    useAxios();
  const [expBookSlot, errorExpBookSlot, loadingExpBookSLot, axiosExpBookSlot] =
    useAxios();

     const form = useForm({
        defaultValues: {
          // slotStartDate: curDate,
          // slotEndDate: tomorrow,
        },
      });
      const {
        register,
        control,
        handleSubmit,
        formState,
        watch,
        setValue,
        getValues,
        resetField,
        reset,
      } = form;
      const { errors } = formState;


  const getData = (url) => {
    axiosFetch({
      axiosInstance: axiosInstance,
      url: url,
      method: "GET",
    });
  };
 

  const handleSearchFieldChange = (e) => {
    if (e.key === "Enter") {
      setSearch(e.target.value);
    }
  };

  const handleLimitChange = (e) => {
    setLimit(e.target.value);
  };

  const onFormSubmit = async (data) => {
    
    let bookedExpData = {

      userId: user.usertype == "admin" ? id : user._id,
      userType: "admin",
      fromDate: data.fromDate || "",
      toDate: data.toDate || "",
    };

    await axiosFetch({
      axiosInstance: axiosInstance,
      url: `${FETCH_API_URL}search=${search}&skip=${page > 0 ? page * limit : 0}&limit=${limit}`,
      method: "POST",
      requestConfig: {
        data: bookedExpData,
      },
    });
  
      setAddUpdate(true);
    };

  useEffect( () => {

    const fetchData = async () => {
      const expBookedSlotData = {
        userId: user?.usertype === "admin" ? id : user?._id,
        userType: "admin",
        fromDate: "",
        toDate: "",
      };
  
      await axiosFetch({
        axiosInstance: axiosInstance,
        url: `${FETCH_API_URL}search=${search}&skip=${page > 0 ? page * limit : 0}&limit=${limit}`,
        method: "POST",
        requestConfig: {
          data: expBookedSlotData,
        },
      });
    };
  
    fetchData();
  
   

    // const interval = setInterval(async () => {
    //     await axiosFetch({
    //       axiosInstance: axiosInstance,
    //       url: `${FETCH_API_URL}search=${search}&skip=${page > 0 ? page * limit : 0}&limit=${limit}`,
    //       method: "POST",
    //       requestConfig: {
    //         data: expBookedSlotData,
    //       },
    //     });
    //   }, 5000);

    }, [FETCH_API_URL,search, page, limit]);
   

  useEffect(() => {
    const toTitleCase = (str) => {
      return str.toLowerCase().replace(/(^|\s|-|\')(\w)/g, (match) => {
        return match.toUpperCase();
      });
    };
    if (resData?.[0]?.success === true && resData?.[0]?.BookedSlots.length > 0) {
      const tempData = resData?.[0]?.BookedSlots.map((item) => {

       

        return {
          _id: `P-${item._id.slice(-5).toUpperCase()}`,
          userName: user.usertype != "admin"? `${item.userName.slice(0, 2)}${"x".repeat(
            item.userName.length - 2
          )}`:item.userName,
          expertName: item.expertName,
          slotTime: item.slotTime,
          slotDate: moment(item.slotDate).format("Do MMMM YYYY"),
          bookingStatus:
                     item.bookingStatus == "B"
                       ? "Booked"
                       : item.bookingStatus == "R"
                       ? "Re-Assigned"
                        : ((item.slotDate == currDate) && moment(currTime, "hh:mm A").isBetween(moment(item.slotTime, "hh:mm A"),moment(item.slotTime, "hh:mm A").clone().add(15, "minutes"))) && item.bookingStatus == "C"
                                     ? "On Going Call"
                                           : "Completed",
              callConnFlag:
             
              ((item.slotDate == currDate) && moment(currTime, "hh:mm A").isBetween(moment(item.slotTime, "hh:mm A"),moment(item.slotTime, "hh:mm A").clone().add(15, "minutes")))
                ? true
                : false,
            userPhone: item.userPhone,
            expertPhone: item.expertPhone,
            slotTimePlus:moment(item.slotTime, "hh:mm A").add(15, "minutes").format("LT"),
            getSlotDate:item.slotDate,
            userQuery:item.userShiftQuery,
            mode:item.mode,
            location: item.mode === "offline"?item.locationName:"None",

        };
      });
      toast.info("Success!! Slot data found", {
        position: toast.POSITION.TOP_RIGHT,
        autoClose: 1000
      });
      setTableData(tempData);
      setTotalCount(resData?.[0]?.totalCount)
      setDownloadExcelData(resData?.[0]?.excelData);

    } else {
       if( resData?.[0]?.success === false || resData?.[0]?.BookedSlots.length == 0){ 
                    toast.error("No data found", {
                      position: toast.POSITION.TOP_RIGHT,
                      autoClose: 1000

                    });
                  }
      setTableData([]);
      setTotalCount(0);
      setDownloadExcelData([]);

    }
  }, [resData]);

  const navigateToCallConnect = async (rowIndex) => {
    if (rowIndex >= 0) {
      const currItem = tableData[rowIndex];

     
       const callFlag = ((currItem.getSlotDate == currDate) && moment(currTime, "hh:mm A").isBetween(moment(currItem.slotTime, "hh:mm A"),moment(currItem.slotTime, "hh:mm A").clone().add(15, "minutes")))
            ? true
            : false;

      if (
        currItem?.callConnFlag == true &&
        currItem?.bookingStatus == "On Going Call" &&
        callFlag
      ) {
        let formData = {
          userPhone: currItem?.userPhone,
          expertPhone: currItem?.expertPhone,
        };

        await axiosCallConn({
          axiosInstance: axiosInstance,
          url: CALL_CONNECT_URL,
          method: "POST",
          requestConfig: {
            data: formData,
          },
        });

        toast.info("Calling is enabled", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000

        });
      } else {
        toast.error("Calling is Disabled", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 1000

        });
      }
    } else {
      // navigate(MODULE_URI);
    }
  };
const openQueryModal = (getQueryFlag=false,rowIndex) => {
  if (rowIndex >= 0) { 
    const currItem = tableData[rowIndex];
    
   
    setCurrQueryMsg(currItem.userQuery||"No user query");
    
   }
   setUserQueryFlag(getQueryFlag);

  }

 

    

   useEffect(() => {
          if(downloadExcelFlag && downloadExcelData && downloadExcelData?.length>0){
            const toTitleCase = (str) => {
              return str.toLowerCase().replace(/(^|\s|-|\')(\w)/g, (match) => {
                return match.toUpperCase();
              });
            };
            let fileName = `${user?.expertName || ""}_BookedSlotExcelData.xlsx`;
          
            const jsonData = downloadExcelData.map((item) => {
          
                 
          
              return {
                Id: `P-${item._id.slice(-5).toUpperCase()}`,
                User_Name: user.usertype != "admin"? `${item.userName.slice(0, 2)}${"x".repeat(
                  item.userName.length - 2
                )}`:item.userName,
                Expert_Name: item.expertName,
                Slot_Time: item.slotTime,
                Slot_Date: moment(item.slotDate).format("Do MMMM YYYY"),
                Status:
                           item.bookingStatus == "B"
                             ? "Booked"
                             : item.bookingStatus == "R"
                             ? "Re-Assigned"
                              : ((item.slotDate == currDate) && moment(currTime, "hh:mm A").isBetween(moment(item.slotTime, "hh:mm A"),moment(item.slotTime, "hh:mm A").clone().add(15, "minutes"))) && item.bookingStatus == "C"
                                           ? "On Going Call"
                                                 : "Completed",
                   
                  User_Query:item.userShiftQuery,
                  Slot_Mode:item.mode,
                  Location: item.mode === "offline"?item.locationName:"None",
          
              };
            });
           
          
            const worksheet = XLSX.utils.json_to_sheet(jsonData);
              const workbook = XLSX.utils.book_new();
              XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
              XLSX.writeFile(workbook, fileName);
          
            
                toast.info(
                  "Excel file downloaded successfully!!",
                  {
                    position: toast.POSITION.TOP_RIGHT,
                    autoClose: 1000

                  }
                );
               
          
             
          }else if(downloadExcelFlag){
            toast.info(
              "No booking slot found for download!!",
              {
                position: toast.POSITION.TOP_RIGHT,
                autoClose: 1000

              }
            );
  
           
          
          }
  
       
        setDownloadExcelFlag(false);
  
  
  
      },[downloadExcelFlag])
   
  return (
    <>
      <div className="card min-height-100">
        <div className="pump-report-top">
          <h2 className="text-navyBlue">Booked Slots</h2>
          <ToastContainer />

          <div className="wrapper">

          <button
                  type="button"
                  className="btn  btn-green rounded-10 mr-10"
                  value="Download"
                  onClick={() => {
                    setDownloadExcelFlag(true);
                   
                  }}
                >
                  Download Excel
                </button> 
                {user?.usertype == "expert" ? (
            <></>
          ) : (
            <Link to="/expert/expertlisting">
              <button className="btn btn-blue rounded-10">Back</button>
            </Link>
          )}
          </div>
          
        </div>
        

<FormProvider {...form}>
          <form onSubmit={handleSubmit(onFormSubmit)} noValidate>
            <div className="row mt-30">
            
             
              
              <div className="col-md-4  tank-col-info">
                <label
                  htmlFor="fromDate"
                  className="text-gray text-semi-bold"
                >
                  From  Date<span className="text-red">*</span>
                </label>
                
                 <input
  id="fromDate"
  type="date"
  className="form-control mb-15"
  {...register("fromDate", {
    required: { value: true, message: "Enter From Date" },
    validate: (value) => {
      const toDate = new Date(getValues("toDate"));
      const fromDate = new Date(value);

      return (
        !getValues("toDate") ||
        fromDate < toDate ||
        "From Date must be earlier than To Date"
      );
    },
  })}
/>
                <p className="text-red">{errors.fromDate?.message}</p>
              </div>
              <div className="col-md-4  tank-col-info">
                <label
                  htmlFor="toDate"
                  className="text-gray text-semi-bold"
                >
                  To Date<span className="text-red">*</span>
                </label>
               
                <input
  id="toDate"
  type="date"
  className="form-control mb-15"
  // min={moment().add(1, "day").format("YYYY-MM-DD")}
  {...register("toDate", {
    required: { value: true, message: "Enter To Date" },
    validate: (value) => {
      const fromDate = new Date(getValues("fromDate"));
      const toDate = new Date(value);

      return (
        !getValues("fromDate") ||
        toDate > fromDate ||
        "To Date must be after From Date"
      );
    },
  })}
/>
                <p className="text-red">{errors.toDate?.message}</p>
              </div>
             

              

              <div className="col-md-4 text-left mt-20">
                <input
                  type="submit"
                  className="btn btn-sm btn-secondary rounded-20"
                  value="Submit"
                />
              </div>
             
            </div>
          </form>
        </FormProvider>




        <div className="pump-search">
          <span className="text-gray">
            {" "}
            Show Entries
            <select
              type="text"
              className="p-5 rounded-20 ml-10 no-bg border-darkGray text-gray"
              onChange={handleLimitChange}
            >
              {PAGE_LIMITS.map((value, index) => (
                <option key={index} value={value}>
                  {value}
                </option>
              ))}
            </select>
          </span>

          <span>
            {" "}
            <input
              type="text"
              className="p-5 rounded-20 ml-10 no-bg border-darkGray text-gray"
              placeholder="Search"
              onKeyDown={handleSearchFieldChange}
            />
          </span>
        </div>
        <div className="company-table ">
          <Table
            tableColumns={expertuserSlotFieldData}
            tableData={tableData}
            tableSettings={{
              page,
              pageSize: limit,
              totalCount,
            }}
            action={true}
            
            handlePage={setPage}
            handleUserQueryFlag={true}

            // handleCallConnectFlag={true}
            // handleCallConnectData={navigateToCallConnect}
            handleUserQuery = {openQueryModal}
          />
        </div>
      </div>
      <UserQueryAlert
          modalFlag={UserQueryFlag}
          queryMessage={CurrQueryMsg}
          modalFunc={openQueryModal}
        
        />
    </>
  );
}
